export default "__VITE_ASSET__6KGvCEad__"